import { Routes, Route, useParams } from "react-router-dom";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import PageLoading from "components/loading/PageLoading";
import NotFoundPage from "components/error/NotFoundPage";
import usePolledQuery from "apollo/usePolledQuery";
import { PollingIntervalGroups } from "apollo/constants";
import useErrorHandle from "hooks/useErrorHandle";
import useTypedFlags from "hooks/useTypedFlags";

import RolePageLayout from "./PageLayout";
import { GET_ROLE } from "./gql";
import RolePermissions from "./Permissions";
import RoleUsedBy from "./UsedBy";

const Role = () => {
  const { customAccessRolesV2 } = useTypedFlags();
  const { onError } = useTypedContext(FlashContext);
  const { roleId } = useParams<{ roleId: string }>();

  const { data, loading, error } = usePolledQuery(GET_ROLE, {
    variables: {
      id: roleId!,
    },
    skip: !roleId,
    onError,
    pollingGroup: PollingIntervalGroups.Default,
  });

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (!data?.role) {
    return loading ? <PageLoading /> : <NotFoundPage />;
  }

  // Exclude system role if someone try to access it
  if (data?.role.isSystem) {
    return <NotFoundPage />;
  }

  return (
    <RolePageLayout role={data.role}>
      <Routes>
        <Route index element={<RolePermissions role={data.role} />} />
        {customAccessRolesV2 && <Route path="used-by" element={<RoleUsedBy role={data.role} />} />}
      </Routes>
    </RolePageLayout>
  );
};

export default Role;
